// world atlas
import worldAtlasThumb1 from '../assets/images/projects/world-atlas/world-atlas-1-thumbnail.jpg';
import worldAtlasThumb2 from '../assets/images/projects/world-atlas/world-atlas-2-thumbnail.jpg';
import worldAtlasThumb3 from '../assets/images/projects/world-atlas/world-atlas-3-thumbnail.jpg';

import worldAtlaslqMIN1 from '../assets/images/projects/world-atlas/world-atlas-1-lqMIN.jpg';
import worldAtlaslqMIN2 from '../assets/images/projects/world-atlas/world-atlas-2-lqMIN.jpg';
import worldAtlaslqMIN3 from '../assets/images/projects/world-atlas/world-atlas-3-lqMIN.jpg';

import worldAtlaslqMAX1 from '../assets/images/projects/world-atlas/world-atlas-1-lqMAX.jpg';
import worldAtlaslqMAX2 from '../assets/images/projects/world-atlas/world-atlas-2-lqMAX.jpg';
import worldAtlaslqMAX3 from '../assets/images/projects/world-atlas/world-atlas-3-lqMAX.jpg';

import worldAtlasrMIN1 from '../assets/images/projects/world-atlas/world-atlas-1-rMIN.jpg';
import worldAtlasrMIN2 from '../assets/images/projects/world-atlas/world-atlas-2-rMIN.jpg';
import worldAtlasrMIN3 from '../assets/images/projects/world-atlas/world-atlas-3-rMIN.jpg';

import worldAtlasrMAX1 from '../assets/images/projects/world-atlas/world-atlas-1-rMAX.jpg';
import worldAtlasrMAX2 from '../assets/images/projects/world-atlas/world-atlas-2-rMAX.jpg';
import worldAtlasrMAX3 from '../assets/images/projects/world-atlas/world-atlas-3-rMAX.jpg';

// restaurant
import restaurantThumb1 from '../assets/images/projects/restaurant-app/restaurant-1-thumbnail.jpg';
import restaurantThumb2 from '../assets/images/projects/restaurant-app/restaurant-2-thumbnail.jpg';
import restaurantThumb3 from '../assets/images/projects/restaurant-app/restaurant-3-thumbnail.jpg';
import restaurantThumb4 from '../assets/images/projects/restaurant-app/restaurant-4-thumbnail.jpg';
import restaurantThumb5 from '../assets/images/projects/restaurant-app/restaurant-5-thumbnail.jpg';
import restaurantThumb6 from '../assets/images/projects/restaurant-app/restaurant-6-thumbnail.jpg';
import restaurantThumb7 from '../assets/images/projects/restaurant-app/restaurant-7-thumbnail.jpg';
import restaurantThumb8 from '../assets/images/projects/restaurant-app/restaurant-8-thumbnail.jpg';

import restaurantlqMIN1 from '../assets/images/projects/restaurant-app/restaurant-1-lqMIN.jpg';
import restaurantlqMIN2 from '../assets/images/projects/restaurant-app/restaurant-2-lqMIN.jpg';
import restaurantlqMIN3 from '../assets/images/projects/restaurant-app/restaurant-3-lqMIN.jpg';
import restaurantlqMIN4 from '../assets/images/projects/restaurant-app/restaurant-4-lqMIN.jpg';
import restaurantlqMIN5 from '../assets/images/projects/restaurant-app/restaurant-5-lqMIN.jpg';
import restaurantlqMIN6 from '../assets/images/projects/restaurant-app/restaurant-6-lqMIN.jpg';
import restaurantlqMIN7 from '../assets/images/projects/restaurant-app/restaurant-7-lqMIN.jpg';
import restaurantlqMIN8 from '../assets/images/projects/restaurant-app/restaurant-8-lqMIN.jpg';

import restaurantlqMAX1 from '../assets/images/projects/restaurant-app/restaurant-1-lqMAX.jpg';
import restaurantlqMAX2 from '../assets/images/projects/restaurant-app/restaurant-2-lqMAX.jpg';
import restaurantlqMAX3 from '../assets/images/projects/restaurant-app/restaurant-3-lqMAX.jpg';
import restaurantlqMAX4 from '../assets/images/projects/restaurant-app/restaurant-4-lqMAX.jpg';
import restaurantlqMAX5 from '../assets/images/projects/restaurant-app/restaurant-5-lqMAX.jpg';
import restaurantlqMAX6 from '../assets/images/projects/restaurant-app/restaurant-6-lqMAX.jpg';
import restaurantlqMAX7 from '../assets/images/projects/restaurant-app/restaurant-7-lqMAX.jpg';
import restaurantlqMAX8 from '../assets/images/projects/restaurant-app/restaurant-8-lqMAX.jpg';

import restaurantrMIN1 from '../assets/images/projects/restaurant-app/restaurant-1-rMIN.jpg';
import restaurantrMIN2 from '../assets/images/projects/restaurant-app/restaurant-2-rMIN.jpg';
import restaurantrMIN3 from '../assets/images/projects/restaurant-app/restaurant-3-rMIN.jpg';
import restaurantrMIN4 from '../assets/images/projects/restaurant-app/restaurant-4-rMIN.jpg';
import restaurantrMIN5 from '../assets/images/projects/restaurant-app/restaurant-5-rMIN.jpg';
import restaurantrMIN6 from '../assets/images/projects/restaurant-app/restaurant-6-rMIN.jpg';
import restaurantrMIN7 from '../assets/images/projects/restaurant-app/restaurant-7-rMIN.jpg';
import restaurantrMIN8 from '../assets/images/projects/restaurant-app/restaurant-8-rMIN.jpg';

import restaurantrMAX1 from '../assets/images/projects/restaurant-app/restaurant-1-rMAX.jpg';
import restaurantrMAX2 from '../assets/images/projects/restaurant-app/restaurant-2-rMAX.jpg';
import restaurantrMAX3 from '../assets/images/projects/restaurant-app/restaurant-3-rMAX.jpg';
import restaurantrMAX4 from '../assets/images/projects/restaurant-app/restaurant-4-rMAX.jpg';
import restaurantrMAX5 from '../assets/images/projects/restaurant-app/restaurant-5-rMAX.jpg';
import restaurantrMAX6 from '../assets/images/projects/restaurant-app/restaurant-6-rMAX.jpg';
import restaurantrMAX7 from '../assets/images/projects/restaurant-app/restaurant-7-rMAX.jpg';
import restaurantrMAX8 from '../assets/images/projects/restaurant-app/restaurant-8-rMAX.jpg';

// checkers
import checkersThumb1 from '../assets/images/projects/checkers/checkers-1-thumbnail.jpg';
import checkersThumb2 from '../assets/images/projects/checkers/checkers-2-thumbnail.jpg';
import checkersThumb3 from '../assets/images/projects/checkers/checkers-3-thumbnail.jpg';
import checkersThumb4 from '../assets/images/projects/checkers/checkers-4-thumbnail.jpg';
import checkersThumb5 from '../assets/images/projects/checkers/checkers-5-thumbnail.jpg';
import checkersThumb6 from '../assets/images/projects/checkers/checkers-6-thumbnail.jpg';
import checkersThumb7 from '../assets/images/projects/checkers/checkers-7-thumbnail.jpg';
import checkersThumb8 from '../assets/images/projects/checkers/checkers-8-thumbnail.jpg';
import checkersThumb9 from '../assets/images/projects/checkers/checkers-9-thumbnail.jpg';

import checkerslqMIN1 from '../assets/images/projects/checkers/checkers-1-lqMIN.jpg';
import checkerslqMIN2 from '../assets/images/projects/checkers/checkers-2-lqMIN.jpg';
import checkerslqMIN3 from '../assets/images/projects/checkers/checkers-3-lqMIN.jpg';
import checkerslqMIN4 from '../assets/images/projects/checkers/checkers-4-lqMIN.jpg';
import checkerslqMIN5 from '../assets/images/projects/checkers/checkers-5-lqMIN.jpg';
import checkerslqMIN6 from '../assets/images/projects/checkers/checkers-6-lqMIN.jpg';
import checkerslqMIN7 from '../assets/images/projects/checkers/checkers-7-lqMIN.jpg';
import checkerslqMIN8 from '../assets/images/projects/checkers/checkers-8-lqMIN.jpg';
import checkerslqMIN9 from '../assets/images/projects/checkers/checkers-9-lqMIN.jpg';

import checkerslqMAX1 from '../assets/images/projects/checkers/checkers-1-lqMAX.jpg';
import checkerslqMAX2 from '../assets/images/projects/checkers/checkers-2-lqMAX.jpg';
import checkerslqMAX3 from '../assets/images/projects/checkers/checkers-3-lqMAX.jpg';
import checkerslqMAX4 from '../assets/images/projects/checkers/checkers-4-lqMAX.jpg';
import checkerslqMAX5 from '../assets/images/projects/checkers/checkers-5-lqMAX.jpg';
import checkerslqMAX6 from '../assets/images/projects/checkers/checkers-6-lqMAX.jpg';
import checkerslqMAX7 from '../assets/images/projects/checkers/checkers-7-lqMAX.jpg';
import checkerslqMAX8 from '../assets/images/projects/checkers/checkers-8-lqMAX.jpg';
import checkerslqMAX9 from '../assets/images/projects/checkers/checkers-9-lqMAX.jpg';

import checkersrMIN1 from '../assets/images/projects/checkers/checkers-1-rMIN.jpg';
import checkersrMIN2 from '../assets/images/projects/checkers/checkers-2-rMIN.jpg';
import checkersrMIN3 from '../assets/images/projects/checkers/checkers-3-rMIN.jpg';
import checkersrMIN4 from '../assets/images/projects/checkers/checkers-4-rMIN.jpg';
import checkersrMIN5 from '../assets/images/projects/checkers/checkers-5-rMIN.jpg';
import checkersrMIN6 from '../assets/images/projects/checkers/checkers-6-rMIN.jpg';
import checkersrMIN7 from '../assets/images/projects/checkers/checkers-7-rMIN.jpg';
import checkersrMIN8 from '../assets/images/projects/checkers/checkers-8-rMIN.jpg';
import checkersrMIN9 from '../assets/images/projects/checkers/checkers-9-rMIN.jpg';

import checkersrMAX1 from '../assets/images/projects/checkers/checkers-1-rMAX.jpg';
import checkersrMAX2 from '../assets/images/projects/checkers/checkers-2-rMAX.jpg';
import checkersrMAX3 from '../assets/images/projects/checkers/checkers-3-rMAX.jpg';
import checkersrMAX4 from '../assets/images/projects/checkers/checkers-4-rMAX.jpg';
import checkersrMAX5 from '../assets/images/projects/checkers/checkers-5-rMAX.jpg';
import checkersrMAX6 from '../assets/images/projects/checkers/checkers-6-rMAX.jpg';
import checkersrMAX7 from '../assets/images/projects/checkers/checkers-7-rMAX.jpg';
import checkersrMAX8 from '../assets/images/projects/checkers/checkers-8-rMAX.jpg';
import checkersrMAX9 from '../assets/images/projects/checkers/checkers-9-rMAX.jpg';

// rl
import rlThumb1 from '../assets/images/projects/reinforcement-learning/rl-1-thumbnail.jpg';
import rlThumb2 from '../assets/images/projects/reinforcement-learning/rl-2-thumbnail.jpg';
import rlThumb3 from '../assets/images/projects/reinforcement-learning/rl-3-thumbnail.jpg';
import rlThumb4 from '../assets/images/projects/reinforcement-learning/rl-4-thumbnail.jpg';

import rllqMIN1 from '../assets/images/projects/reinforcement-learning/rl-1-lqMIN.jpg';
import rllqMIN2 from '../assets/images/projects/reinforcement-learning/rl-2-lqMIN.jpg';
import rllqMIN3 from '../assets/images/projects/reinforcement-learning/rl-3-lqMIN.jpg';
import rllqMIN4 from '../assets/images/projects/reinforcement-learning/rl-4-lqMIN.jpg';

import rllqMAX1 from '../assets/images/projects/reinforcement-learning/rl-1-lqMAX.jpg';
import rllqMAX2 from '../assets/images/projects/reinforcement-learning/rl-2-lqMAX.jpg';
import rllqMAX3 from '../assets/images/projects/reinforcement-learning/rl-3-lqMAX.jpg';
import rllqMAX4 from '../assets/images/projects/reinforcement-learning/rl-4-lqMAX.jpg';

import rlrMIN1 from '../assets/images/projects/reinforcement-learning/rl-1-rMIN.jpg';
import rlrMIN2 from '../assets/images/projects/reinforcement-learning/rl-2-rMIN.jpg';
import rlrMIN3 from '../assets/images/projects/reinforcement-learning/rl-3-rMIN.jpg';
import rlrMIN4 from '../assets/images/projects/reinforcement-learning/rl-4-rMIN.jpg';

import rlrMAX1 from '../assets/images/projects/reinforcement-learning/rl-1-rMAX.jpg';
import rlrMAX2 from '../assets/images/projects/reinforcement-learning/rl-2-rMAX.jpg';
import rlrMAX3 from '../assets/images/projects/reinforcement-learning/rl-3-rMAX.jpg';
import rlrMAX4 from '../assets/images/projects/reinforcement-learning/rl-4-rMAX.jpg';

// xcovers
import xcoversThumb1 from '../assets/images/projects/xcovers/xcovers1-thumbnail.avif';
import xcoversThumb2 from '../assets/images/projects/xcovers/xcovers2-thumbnail.avif';
import xcoversThumb3 from '../assets/images/projects/xcovers/xcovers3-thumbnail.avif';
import xcoversThumb4 from '../assets/images/projects/xcovers/xcovers4-thumbnail.avif';

import xcoverslqMIN1 from '../assets/images/projects/xcovers/xcovers1-lqMIN.avif';
import xcoverslqMIN2 from '../assets/images/projects/xcovers/xcovers2-lqMIN.avif';
import xcoverslqMIN3 from '../assets/images/projects/xcovers/xcovers3-lqMIN.avif';
import xcoverslqMIN4 from '../assets/images/projects/xcovers/xcovers4-lqMIN.avif';

import xcoverslqMAX1 from '../assets/images/projects/xcovers/xcovers1-lqMAX.avif';
import xcoverslqMAX2 from '../assets/images/projects/xcovers/xcovers2-lqMAX.avif';
import xcoverslqMAX3 from '../assets/images/projects/xcovers/xcovers3-lqMAX.avif';
import xcoverslqMAX4 from '../assets/images/projects/xcovers/xcovers4-lqMAX.avif';

import xcoversrMIN1 from '../assets/images/projects/xcovers/xcovers1-rMIN.avif';
import xcoversrMIN2 from '../assets/images/projects/xcovers/xcovers2-rMIN.avif';
import xcoversrMIN3 from '../assets/images/projects/xcovers/xcovers3-rMIN.avif';
import xcoversrMIN4 from '../assets/images/projects/xcovers/xcovers4-rMIN.avif';

import xcoversrMAX1 from '../assets/images/projects/xcovers/xcovers1-rMAX.avif';
import xcoversrMAX2 from '../assets/images/projects/xcovers/xcovers2-rMAX.avif';
import xcoversrMAX3 from '../assets/images/projects/xcovers/xcovers3-rMAX.avif';
import xcoversrMAX4 from '../assets/images/projects/xcovers/xcovers4-rMAX.avif';

// online experiment
import oeThumb2 from '../assets/images/projects/online-experiment-1/oe-2-thumbnail.jpg';
import oeThumb3 from '../assets/images/projects/online-experiment-1/oe-3-thumbnail.jpg';
import oeThumb4 from '../assets/images/projects/online-experiment-1/oe-4-thumbnail.jpg';
import oeThumb5 from '../assets/images/projects/online-experiment-1/oe-5-thumbnail.jpg';

import oelqMIN2 from '../assets/images/projects/online-experiment-1/oe-2-lqMIN.jpg';
import oelqMIN3 from '../assets/images/projects/online-experiment-1/oe-3-lqMIN.jpg';
import oelqMIN4 from '../assets/images/projects/online-experiment-1/oe-4-lqMIN.jpg';
import oelqMIN5 from '../assets/images/projects/online-experiment-1/oe-5-lqMIN.jpg';

import oelqMAX2 from '../assets/images/projects/online-experiment-1/oe-2-lqMAX.jpg';
import oelqMAX3 from '../assets/images/projects/online-experiment-1/oe-3-lqMAX.jpg';
import oelqMAX4 from '../assets/images/projects/online-experiment-1/oe-4-lqMAX.jpg';
import oelqMAX5 from '../assets/images/projects/online-experiment-1/oe-5-lqMAX.jpg';

import oerMIN2 from '../assets/images/projects/online-experiment-1/oe-2-rMIN.jpg';
import oerMIN3 from '../assets/images/projects/online-experiment-1/oe-3-rMIN.jpg';
import oerMIN4 from '../assets/images/projects/online-experiment-1/oe-4-rMIN.jpg';
import oerMIN5 from '../assets/images/projects/online-experiment-1/oe-5-rMIN.jpg';

import oerMAX2 from '../assets/images/projects/online-experiment-1/oe-2-rMAX.jpg';
import oerMAX3 from '../assets/images/projects/online-experiment-1/oe-3-rMAX.jpg';
import oerMAX4 from '../assets/images/projects/online-experiment-1/oe-4-rMAX.jpg';
import oerMAX5 from '../assets/images/projects/online-experiment-1/oe-5-rMAX.jpg';

// black jack
import blackJackVid1 from '../assets/images/projects/blackJack/vids/vid1.mp4';
import blackJackVid2 from '../assets/images/projects/blackJack/vids/vid2.mp4';

import blackJackThumb1 from '../assets/images/projects/blackJack/photo1-thumbnail.jpg';
import blackJackThumb2 from '../assets/images/projects/blackJack/photo2-thumbnail.jpg';
import blackJackThumb3 from '../assets/images/projects/blackJack/photo3-thumbnail.jpg';

import blackJacklqMAX1 from '../assets/images/projects/blackJack/photo1-lqMAX.jpg';
import blackJacklqMAX2 from '../assets/images/projects/blackJack/photo2-lqMAX.jpg';
import blackJacklqMAX3 from '../assets/images/projects/blackJack/photo3-lqMAX.jpg';

import blackJacklqMIN1 from '../assets/images/projects/blackJack/photo1-lqMIN.jpg';
import blackJacklqMIN2 from '../assets/images/projects/blackJack/photo2-lqMIN.jpg';
import blackJacklqMIN3 from '../assets/images/projects/blackJack/photo3-lqMIN.jpg';

import blackJackrMAX1 from '../assets/images/projects/blackJack/photo1-rMAX.jpg';
import blackJackrMAX2 from '../assets/images/projects/blackJack/photo2-rMAX.jpg';
import blackJackrMAX3 from '../assets/images/projects/blackJack/photo3-rMAX.jpg';

import blackJackrMIN1 from '../assets/images/projects/blackJack/photo1-rMIN.jpg';
import blackJackrMIN2 from '../assets/images/projects/blackJack/photo2-rMIN.jpg';
import blackJackrMIN3 from '../assets/images/projects/blackJack/photo3-rMIN.jpg';

// facebook friends network
import networkGraphVid1 from '../assets/images/projects/network-graph/vids/network-graph-vid-1.mp4';
import networkGraphVid2 from '../assets/images/projects/network-graph/vids/network-graph-vid-2.mp4';

import networkGraphThumb1 from '../assets/images/projects/network-graph/network-graph-0-thumbnail.jpg';
import networkGraphThumb2 from '../assets/images/projects/network-graph/network-graph-1-thumbnail.jpg';
import networkGraphThumb3 from '../assets/images/projects/network-graph/network-graph-2-thumbnail.jpg';

import networkGraphlqMAX1 from '../assets/images/projects/network-graph/network-graph-0-lqMAX.jpg';
import networkGraphlqMAX2 from '../assets/images/projects/network-graph/network-graph-1-lqMAX.jpg';
import networkGraphlqMAX3 from '../assets/images/projects/network-graph/network-graph-2-lqMAX.jpg';

import networkGraphlqMIN1 from '../assets/images/projects/network-graph/network-graph-0-lqMIN.jpg';
import networkGraphlqMIN2 from '../assets/images/projects/network-graph/network-graph-1-lqMIN.jpg';
import networkGraphlqMIN3 from '../assets/images/projects/network-graph/network-graph-2-lqMIN.jpg';

import networkGraphrMAX1 from '../assets/images/projects/network-graph/network-graph-0-rMAX.jpg';
import networkGraphrMAX2 from '../assets/images/projects/network-graph/network-graph-1-rMAX.jpg';
import networkGraphrMAX3 from '../assets/images/projects/network-graph/network-graph-2-rMAX.jpg';

import networkGraphrMIN1 from '../assets/images/projects/network-graph/network-graph-0-rMIN.jpg';
import networkGraphrMIN2 from '../assets/images/projects/network-graph/network-graph-1-rMIN.jpg';
import networkGraphrMIN3 from '../assets/images/projects/network-graph/network-graph-2-rMIN.jpg';

// machine learning robotical
import machineLearningRoboticalThumb1 from '../assets/images/projects/machine-learning-robotical/mlr-1-thumbnail.avif';
import machineLearningRoboticalThumb2 from '../assets/images/projects/machine-learning-robotical/mlr-2-thumbnail.avif';
import machineLearningRoboticalThumb3 from '../assets/images/projects/machine-learning-robotical/mlr-3-thumbnail.avif';

import machineLearningRoboticallqMIN1 from '../assets/images/projects/machine-learning-robotical/mlr-1-lqMIN.avif';
import machineLearningRoboticallqMIN2 from '../assets/images/projects/machine-learning-robotical/mlr-2-lqMIN.avif';
import machineLearningRoboticallqMIN3 from '../assets/images/projects/machine-learning-robotical/mlr-3-lqMIN.avif';

import machineLearningRoboticallqMAX1 from '../assets/images/projects/machine-learning-robotical/mlr-1-lqMAX.avif';
import machineLearningRoboticallqMAX2 from '../assets/images/projects/machine-learning-robotical/mlr-2-lqMAX.avif';
import machineLearningRoboticallqMAX3 from '../assets/images/projects/machine-learning-robotical/mlr-3-lqMAX.avif';

import machineLearningRoboticallrMIN1 from '../assets/images/projects/machine-learning-robotical/mlr-1-rMIN.avif';
import machineLearningRoboticallrMIN2 from '../assets/images/projects/machine-learning-robotical/mlr-2-rMIN.avif';
import machineLearningRoboticallrMIN3 from '../assets/images/projects/machine-learning-robotical/mlr-3-rMIN.avif';

import machineLearningRoboticallrMAX1 from '../assets/images/projects/machine-learning-robotical/mlr-1-rMAX.avif';
import machineLearningRoboticallrMAX2 from '../assets/images/projects/machine-learning-robotical/mlr-2-rMAX.avif';
import machineLearningRoboticallrMAX3 from '../assets/images/projects/machine-learning-robotical/mlr-3-rMAX.avif';

import machineLearningRoboticallVideo1 from '../assets/images/projects/machine-learning-robotical/vids/mlr-vid-1.mp4';

// marty controller
import martyControllerVideo1 from '../assets/images/projects/marty-controller/vids/marty-controller.mp4';

import martyControllerThumb1 from '../assets/images/projects/marty-controller/mc-1-thumbnail.avif';
import martyControllerThumb2 from '../assets/images/projects/marty-controller/mc-2-thumbnail.avif';
import martyControllerThumb3 from '../assets/images/projects/marty-controller/mc-3-thumbnail.avif';
import martyControllerThumb4 from '../assets/images/projects/marty-controller/mc-4-thumbnail.avif';

import martyControllerlqMIN1 from '../assets/images/projects/marty-controller/mc-1-lqMIN.avif';
import martyControllerlqMIN2 from '../assets/images/projects/marty-controller/mc-2-lqMIN.avif';
import martyControllerlqMIN3 from '../assets/images/projects/marty-controller/mc-3-lqMIN.avif';
import martyControllerlqMIN4 from '../assets/images/projects/marty-controller/mc-4-lqMIN.avif';

import martyControllerlqMAX1 from '../assets/images/projects/marty-controller/mc-1-lqMAX.avif';
import martyControllerlqMAX2 from '../assets/images/projects/marty-controller/mc-2-lqMAX.avif';
import martyControllerlqMAX3 from '../assets/images/projects/marty-controller/mc-3-lqMAX.avif';
import martyControllerlqMAX4 from '../assets/images/projects/marty-controller/mc-4-lqMAX.avif';

import martyControllerrMIN1 from '../assets/images/projects/marty-controller/mc-1-rMIN.avif';
import martyControllerrMIN2 from '../assets/images/projects/marty-controller/mc-2-rMIN.avif';
import martyControllerrMIN3 from '../assets/images/projects/marty-controller/mc-3-rMIN.avif';
import martyControllerrMIN4 from '../assets/images/projects/marty-controller/mc-4-rMIN.avif';

import martyControllerrMAX1 from '../assets/images/projects/marty-controller/mc-1-rMAX.avif';
import martyControllerrMAX2 from '../assets/images/projects/marty-controller/mc-2-rMAX.avif';
import martyControllerrMAX3 from '../assets/images/projects/marty-controller/mc-3-rMAX.avif';
import martyControllerrMAX4 from '../assets/images/projects/marty-controller/mc-4-rMAX.avif';

// learning portal
import learningPortalVideo1 from '../assets/images/projects/learning-portal/vids/lp-video-1.mp4';

import learningPortalThumb1 from '../assets/images/projects/learning-portal/lp-1-thumbnail.avif';
import learningPortalThumb2 from '../assets/images/projects/learning-portal/lp-2-thumbnail.avif';

import learningPortallqMIN1 from '../assets/images/projects/learning-portal/lp-1-lqMIN.avif';
import learningPortallqMIN2 from '../assets/images/projects/learning-portal/lp-2-lqMIN.avif';

import learningPortallqMAX1 from '../assets/images/projects/learning-portal/lp-1-lqMAX.avif';
import learningPortallqMAX2 from '../assets/images/projects/learning-portal/lp-2-lqMAX.avif';

import learningPortallrMIN1 from '../assets/images/projects/learning-portal/lp-1-rMIN.avif';
import learningPortallrMIN2 from '../assets/images/projects/learning-portal/lp-2-rMIN.avif';

import learningPortallrMAX1 from '../assets/images/projects/learning-portal/lp-1-rMAX.avif';
import learningPortallrMAX2 from '../assets/images/projects/learning-portal/lp-2-rMAX.avif';

// code assess
import codeAssessVideo1 from '../assets/images/projects/code-assess/vids/ca-vid-1.mp4';
import codeAssessVideo2 from '../assets/images/projects/code-assess/vids/ca-vid-2.mp4';
import codeAssessVideo3 from '../assets/images/projects/code-assess/vids/ca-vid-3.mp4';
import codeAssessVideo4 from '../assets/images/projects/code-assess/vids/ca-vid-4.mp4';

import codeAssessThumb1 from '../assets/images/projects/code-assess/ca-1-thumbnail.avif';
import codeAssessThumb2 from '../assets/images/projects/code-assess/ca-2-thumbnail.avif';
import codeAssessThumb3 from '../assets/images/projects/code-assess/ca-3-thumbnail.avif';
import codeAssessThumb4 from '../assets/images/projects/code-assess/ca-4-thumbnail.avif';
import codeAssessThumb5 from '../assets/images/projects/code-assess/ca-5-thumbnail.avif';
import codeAssessThumb6 from '../assets/images/projects/code-assess/ca-6-thumbnail.avif';

import codeAssesslqMIN1 from '../assets/images/projects/code-assess/ca-1-lqMIN.avif';
import codeAssesslqMIN2 from '../assets/images/projects/code-assess/ca-2-lqMIN.avif';
import codeAssesslqMIN3 from '../assets/images/projects/code-assess/ca-3-lqMIN.avif';
import codeAssesslqMIN4 from '../assets/images/projects/code-assess/ca-4-lqMIN.avif';
import codeAssesslqMIN5 from '../assets/images/projects/code-assess/ca-5-lqMIN.avif';
import codeAssesslqMIN6 from '../assets/images/projects/code-assess/ca-6-lqMIN.avif';

import codeAssesslqMAX1 from '../assets/images/projects/code-assess/ca-1-lqMAX.avif';
import codeAssesslqMAX2 from '../assets/images/projects/code-assess/ca-2-lqMAX.avif';
import codeAssesslqMAX3 from '../assets/images/projects/code-assess/ca-3-lqMAX.avif';
import codeAssesslqMAX4 from '../assets/images/projects/code-assess/ca-4-lqMAX.avif';
import codeAssesslqMAX5 from '../assets/images/projects/code-assess/ca-5-lqMAX.avif';
import codeAssesslqMAX6 from '../assets/images/projects/code-assess/ca-6-lqMAX.avif';

import codeAssessrMIN1 from '../assets/images/projects/code-assess/ca-1-rMIN.avif';
import codeAssessrMIN2 from '../assets/images/projects/code-assess/ca-2-rMIN.avif';
import codeAssessrMIN3 from '../assets/images/projects/code-assess/ca-3-rMIN.avif';
import codeAssessrMIN4 from '../assets/images/projects/code-assess/ca-4-rMIN.avif';
import codeAssessrMIN5 from '../assets/images/projects/code-assess/ca-5-rMIN.avif';
import codeAssessrMIN6 from '../assets/images/projects/code-assess/ca-6-rMIN.avif';

import codeAssessrMAX1 from '../assets/images/projects/code-assess/ca-1-rMAX.avif';
import codeAssessrMAX2 from '../assets/images/projects/code-assess/ca-2-rMAX.avif';
import codeAssessrMAX3 from '../assets/images/projects/code-assess/ca-3-rMAX.avif';
import codeAssessrMAX4 from '../assets/images/projects/code-assess/ca-4-rMAX.avif';
import codeAssessrMAX5 from '../assets/images/projects/code-assess/ca-5-rMAX.avif';
import codeAssessrMAX6 from '../assets/images/projects/code-assess/ca-6-rMAX.avif';

// mini games
import miniGamesVid1 from '../assets/images/projects/mini-games/vids/mg-vid-1.mp4';
import miniGamesVid2 from '../assets/images/projects/mini-games/vids/mg-vid-2.mp4';
import miniGamesVid3 from '../assets/images/projects/mini-games/vids/mg-vid-3.mp4';

import miniGamesThumb1 from '../assets/images/projects/mini-games/mg-1-thumbnail.avif';
import miniGamesThumb2 from '../assets/images/projects/mini-games/mg-2-thumbnail.avif';
import miniGamesThumb3 from '../assets/images/projects/mini-games/mg-3-thumbnail.avif';

import miniGameslqMIN1 from '../assets/images/projects/mini-games/mg-1-lqMIN.avif';
import miniGameslqMIN2 from '../assets/images/projects/mini-games/mg-2-lqMIN.avif';
import miniGameslqMIN3 from '../assets/images/projects/mini-games/mg-3-lqMIN.avif';

import miniGameslqMAX1 from '../assets/images/projects/mini-games/mg-1-lqMAX.avif';
import miniGameslqMAX2 from '../assets/images/projects/mini-games/mg-2-lqMAX.avif';
import miniGameslqMAX3 from '../assets/images/projects/mini-games/mg-3-lqMAX.avif';

import miniGamesrMIN1 from '../assets/images/projects/mini-games/mg-1-rMIN.avif';
import miniGamesrMIN2 from '../assets/images/projects/mini-games/mg-2-rMIN.avif';
import miniGamesrMIN3 from '../assets/images/projects/mini-games/mg-3-rMIN.avif';

import miniGamesrMAX1 from '../assets/images/projects/mini-games/mg-1-rMAX.avif';
import miniGamesrMAX2 from '../assets/images/projects/mini-games/mg-2-rMAX.avif';
import miniGamesrMAX3 from '../assets/images/projects/mini-games/mg-3-rMAX.avif';

// Blocks to python transpiler
import blocksToPythonVid1 from '../assets/images/projects/blocks-to-python-transpiler/vids/btp-vid-1.mp4';

import blocksToPythonThumb1 from '../assets/images/projects/blocks-to-python-transpiler/btp-1-thumbnail.avif';
import blocksToPythonThumb2 from '../assets/images/projects/blocks-to-python-transpiler/btp-2-thumbnail.avif';

import blocksToPythonlqMIN1 from '../assets/images/projects/blocks-to-python-transpiler/btp-1-lqMIN.avif';
import blocksToPythonlqMIN2 from '../assets/images/projects/blocks-to-python-transpiler/btp-2-lqMIN.avif';

import blocksToPythonlqMAX1 from '../assets/images/projects/blocks-to-python-transpiler/btp-1-lqMAX.avif';
import blocksToPythonlqMAX2 from '../assets/images/projects/blocks-to-python-transpiler/btp-2-lqMAX.avif';

import blocksToPythonrMIN1 from '../assets/images/projects/blocks-to-python-transpiler/btp-1-rMIN.avif';
import blocksToPythonrMIN2 from '../assets/images/projects/blocks-to-python-transpiler/btp-2-rMIN.avif';

import blocksToPythonrMAX1 from '../assets/images/projects/blocks-to-python-transpiler/btp-1-rMAX.avif';
import blocksToPythonrMAX2 from '../assets/images/projects/blocks-to-python-transpiler/btp-2-rMAX.avif';

// sensors dashboard
import sensorsDashboardVid1 from '../assets/images/projects/sensors-dashboard/vids/sd-vid-1.mp4';
import sensorsDashboardVid2 from '../assets/images/projects/sensors-dashboard/vids/sd-vid-2.mp4';

import sensorsDashboardThumb1 from '../assets/images/projects/sensors-dashboard/sd-1-thumbnail.avif';

import sensorsDashboardlqMIN1 from '../assets/images/projects/sensors-dashboard/sd-1-lqMIN.avif';

import sensorsDashboardlqMAX1 from '../assets/images/projects/sensors-dashboard/sd-1-lqMAX.avif';

import sensorsDashboardrMIN1 from '../assets/images/projects/sensors-dashboard/sd-1-rMIN.avif';

import sensorsDashboardrMAX1 from '../assets/images/projects/sensors-dashboard/sd-1-rMAX.avif';

import { ImagesVersionsInterface } from '../types/images-versions-interface';

// scratch jr web
import scratchJrWebThumb1 from '../assets/images/projects/scratch-jr-web/sj-1-thumbnail.avif';
import scratchJrWebThumb2 from '../assets/images/projects/scratch-jr-web/sj-2-thumbnail.avif';
import scratchJrWebThumb3 from '../assets/images/projects/scratch-jr-web/sj-3-thumbnail.avif';

import scratchJrWeblqMIN1 from '../assets/images/projects/scratch-jr-web/sj-1-lqMIN.avif';
import scratchJrWeblqMIN2 from '../assets/images/projects/scratch-jr-web/sj-2-lqMIN.avif';
import scratchJrWeblqMIN3 from '../assets/images/projects/scratch-jr-web/sj-3-lqMIN.avif';

import scratchJrWeblqMAX1 from '../assets/images/projects/scratch-jr-web/sj-1-lqMAX.avif';
import scratchJrWeblqMAX2 from '../assets/images/projects/scratch-jr-web/sj-2-lqMAX.avif';
import scratchJrWeblqMAX3 from '../assets/images/projects/scratch-jr-web/sj-3-lqMAX.avif';

import scratchJrWebrMIN1 from '../assets/images/projects/scratch-jr-web/sj-1-rMIN.avif';
import scratchJrWebrMIN2 from '../assets/images/projects/scratch-jr-web/sj-2-rMIN.avif';
import scratchJrWebrMIN3 from '../assets/images/projects/scratch-jr-web/sj-3-rMIN.avif';

import scratchJrWebrMAX1 from '../assets/images/projects/scratch-jr-web/sj-1-rMAX.avif';
import scratchJrWebrMAX2 from '../assets/images/projects/scratch-jr-web/sj-2-rMAX.avif';
import scratchJrWebrMAX3 from '../assets/images/projects/scratch-jr-web/sj-3-rMAX.avif';

// news hub
import newsHubVid1 from '../assets/images/projects/news-hub-robotical/vids/nh-vid-1.mp4';

// dreams for littles 
import dreamsForLittlesVid1 from '../assets/images/projects/dreams-for-littles/vids/dfl-vid-1.mp4';

import dreamsForLittlesThumb1 from '../assets/images/projects/dreams-for-littles/dfl-1-thumbnail.avif';
import dreamsForLittlesThumb2 from '../assets/images/projects/dreams-for-littles/dfl-2-thumbnail.avif';
import dreamsForLittlesThumb3 from '../assets/images/projects/dreams-for-littles/dfl-3-thumbnail.avif';
import dreamsForLittlesThumb4 from '../assets/images/projects/dreams-for-littles/dfl-4-thumbnail.avif';
import dreamsForLittlesThumb5 from '../assets/images/projects/dreams-for-littles/dfl-5-thumbnail.avif';

import dreamsForLittleslqMIN1 from '../assets/images/projects/dreams-for-littles/dfl-1-lqMIN.avif';
import dreamsForLittleslqMIN2 from '../assets/images/projects/dreams-for-littles/dfl-2-lqMIN.avif';
import dreamsForLittleslqMIN3 from '../assets/images/projects/dreams-for-littles/dfl-3-lqMIN.avif';
import dreamsForLittleslqMIN4 from '../assets/images/projects/dreams-for-littles/dfl-4-lqMIN.avif';
import dreamsForLittleslqMIN5 from '../assets/images/projects/dreams-for-littles/dfl-5-lqMIN.avif';

import dreamsForLittleslqMAX1 from '../assets/images/projects/dreams-for-littles/dfl-1-lqMAX.avif';
import dreamsForLittleslqMAX2 from '../assets/images/projects/dreams-for-littles/dfl-2-lqMAX.avif';
import dreamsForLittleslqMAX3 from '../assets/images/projects/dreams-for-littles/dfl-3-lqMAX.avif';
import dreamsForLittleslqMAX4 from '../assets/images/projects/dreams-for-littles/dfl-4-lqMAX.avif';
import dreamsForLittleslqMAX5 from '../assets/images/projects/dreams-for-littles/dfl-5-lqMAX.avif';

import dreamsForLittlesrMIN1 from '../assets/images/projects/dreams-for-littles/dfl-1-rMIN.avif';
import dreamsForLittlesrMIN2 from '../assets/images/projects/dreams-for-littles/dfl-2-rMIN.avif';
import dreamsForLittlesrMIN3 from '../assets/images/projects/dreams-for-littles/dfl-3-rMIN.avif';
import dreamsForLittlesrMIN4 from '../assets/images/projects/dreams-for-littles/dfl-4-rMIN.avif';
import dreamsForLittlesrMIN5 from '../assets/images/projects/dreams-for-littles/dfl-5-rMIN.avif';

import dreamsForLittlesrMAX1 from '../assets/images/projects/dreams-for-littles/dfl-1-rMAX.avif';
import dreamsForLittlesrMAX2 from '../assets/images/projects/dreams-for-littles/dfl-2-rMAX.avif';
import dreamsForLittlesrMAX3 from '../assets/images/projects/dreams-for-littles/dfl-3-rMAX.avif';
import dreamsForLittlesrMAX4 from '../assets/images/projects/dreams-for-littles/dfl-4-rMAX.avif';
import dreamsForLittlesrMAX5 from '../assets/images/projects/dreams-for-littles/dfl-5-rMAX.avif';

// diy alarm system
import diyAlarmSystemVideo1 from '../assets/images/projects/diy-alarm-system/vids/diy-alarm-system.mp4';

import diyAlarmSystemThumb1 from '../assets/images/projects/diy-alarm-system/IMG_4645-thumbnail.avif';
import diyAlarmSystemThumb2 from '../assets/images/projects/diy-alarm-system/IMG_4646-thumbnail.avif';

import diyAlarmSystemlqMIN1 from '../assets/images/projects/diy-alarm-system/IMG_4645-lqMIN.avif';
import diyAlarmSystemlqMIN2 from '../assets/images/projects/diy-alarm-system/IMG_4646-lqMIN.avif';

import diyAlarmSystemlqMAX1 from '../assets/images/projects/diy-alarm-system/IMG_4645-lqMAX.avif';
import diyAlarmSystemlqMAX2 from '../assets/images/projects/diy-alarm-system/IMG_4646-lqMAX.avif';

import diyAlarmSystemrMIN1 from '../assets/images/projects/diy-alarm-system/IMG_4645-rMIN.avif';
import diyAlarmSystemrMIN2 from '../assets/images/projects/diy-alarm-system/IMG_4646-rMIN.avif';

import diyAlarmSystemrMAX1 from '../assets/images/projects/diy-alarm-system/IMG_4645-rMAX.avif';
import diyAlarmSystemrMAX2 from '../assets/images/projects/diy-alarm-system/IMG_4646-rMAX.avif';

// smart pot
import smartPotVideo from '../assets/images/projects/smart-pot/vids/smart-pot-watering.mp4';

import smartPotDeviceThumb from '../assets/images/projects/smart-pot/smart-pot-device-thumbnail.avif';
import smartPotDashboardThumb from '../assets/images/projects/smart-pot/smart-pot-dashboard-thumbnail.avif';
import smartPotElectronicsThumb from '../assets/images/projects/smart-pot/smart-pot-electronics-thumbnail.avif';
import smartPotPumpThumb from '../assets/images/projects/smart-pot/smart-pot-pump-thumbnail.avif';

import smartPotDeviceLqMIN from '../assets/images/projects/smart-pot/smart-pot-device-lqMIN.avif';
import smartPotDashboardLqMIN from '../assets/images/projects/smart-pot/smart-pot-dashboard-lqMIN.avif';
import smartPotElectronicsLqMIN from '../assets/images/projects/smart-pot/smart-pot-electronics-lqMIN.avif';
import smartPotPumpLqMIN from '../assets/images/projects/smart-pot/smart-pot-pump-lqMIN.avif';

import smartPotDeviceLqMAX from '../assets/images/projects/smart-pot/smart-pot-device-lqMAX.avif';
import smartPotDashboardLqMAX from '../assets/images/projects/smart-pot/smart-pot-dashboard-lqMAX.avif';
import smartPotElectronicsLqMAX from '../assets/images/projects/smart-pot/smart-pot-electronics-lqMAX.avif';
import smartPotPumpLqMAX from '../assets/images/projects/smart-pot/smart-pot-pump-lqMAX.avif';

import smartPotDeviceRMIN from '../assets/images/projects/smart-pot/smart-pot-device-rMIN.avif';
import smartPotDashboardRMIN from '../assets/images/projects/smart-pot/smart-pot-dashboard-rMIN.avif';
import smartPotElectronicsRMIN from '../assets/images/projects/smart-pot/smart-pot-electronics-rMIN.avif';
import smartPotPumpRMIN from '../assets/images/projects/smart-pot/smart-pot-pump-rMIN.avif';

import smartPotDeviceRMAX from '../assets/images/projects/smart-pot/smart-pot-device-rMAX.avif';
import smartPotDashboardRMAX from '../assets/images/projects/smart-pot/smart-pot-dashboard-rMAX.avif';
import smartPotElectronicsRMAX from '../assets/images/projects/smart-pot/smart-pot-electronics-rMAX.avif';
import smartPotPumpRMAX from '../assets/images/projects/smart-pot/smart-pot-pump-rMAX.avif';

// smart mirror
import smartMirrorFinishedThumb from '../assets/images/projects/smart-mirror/smart-mirror-finished-thumbnail.jpg';
import smartMirrorUiThumb from '../assets/images/projects/smart-mirror/smart-mirror-ui-thumbnail.jpg';
import smartMirrorBackThumb from '../assets/images/projects/smart-mirror/smart-mirror-back-thumbnail.jpg';
import smartMirrorSensorThumb from '../assets/images/projects/smart-mirror/smart-mirror-sensor-thumbnail.jpg';
import smartMirrorPiThumb from '../assets/images/projects/smart-mirror/smart-mirror-pi-thumbnail.jpg';

import smartMirrorFinishedlqMIN from '../assets/images/projects/smart-mirror/smart-mirror-finished-lqMIN.jpg';
import smartMirrorUilqMIN from '../assets/images/projects/smart-mirror/smart-mirror-ui-lqMIN.jpg';
import smartMirrorBacklqMIN from '../assets/images/projects/smart-mirror/smart-mirror-back-lqMIN.jpg';
import smartMirrorSensorlqMIN from '../assets/images/projects/smart-mirror/smart-mirror-sensor-lqMIN.jpg';
import smartMirrorPilqMIN from '../assets/images/projects/smart-mirror/smart-mirror-pi-lqMIN.jpg';

import smartMirrorFinishedlqMAX from '../assets/images/projects/smart-mirror/smart-mirror-finished-lqMAX.jpg';
import smartMirrorUilqMAX from '../assets/images/projects/smart-mirror/smart-mirror-ui-lqMAX.jpg';
import smartMirrorBacklqMAX from '../assets/images/projects/smart-mirror/smart-mirror-back-lqMAX.jpg';
import smartMirrorSensorlqMAX from '../assets/images/projects/smart-mirror/smart-mirror-sensor-lqMAX.jpg';
import smartMirrorPilqMAX from '../assets/images/projects/smart-mirror/smart-mirror-pi-lqMAX.jpg';

import smartMirrorFinishedrMIN from '../assets/images/projects/smart-mirror/smart-mirror-finished-rMIN.jpg';
import smartMirrorUirMIN from '../assets/images/projects/smart-mirror/smart-mirror-ui-rMIN.jpg';
import smartMirrorBackrMIN from '../assets/images/projects/smart-mirror/smart-mirror-back-rMIN.jpg';
import smartMirrorSensorrMIN from '../assets/images/projects/smart-mirror/smart-mirror-sensor-rMIN.jpg';
import smartMirrorPirMIN from '../assets/images/projects/smart-mirror/smart-mirror-pi-rMIN.jpg';

import smartMirrorFinishedrMAX from '../assets/images/projects/smart-mirror/smart-mirror-finished-rMAX.jpg';
import smartMirrorUirMAX from '../assets/images/projects/smart-mirror/smart-mirror-ui-rMAX.jpg';
import smartMirrorBackrMAX from '../assets/images/projects/smart-mirror/smart-mirror-back-rMAX.jpg';
import smartMirrorSensorrMAX from '../assets/images/projects/smart-mirror/smart-mirror-sensor-rMAX.jpg';
import smartMirrorPirMAX from '../assets/images/projects/smart-mirror/smart-mirror-pi-rMAX.jpg';

import smartMirrorMountedVideo from '../assets/images/projects/smart-mirror/smart-mirror-mounted.mp4';
import smartMirrorPrototypeVideo from '../assets/images/projects/smart-mirror/smart-mirror-prototype.mp4';

// marty quest
import martyQuestVideo1 from '../assets/images/projects/marty-quest/vids/mq-video-1.mp4';

import martyQuestThumb1 from '../assets/images/projects/marty-quest/mq-1-thumbnail.avif';
import martyQuestThumb2 from '../assets/images/projects/marty-quest/mq-2-thumbnail.avif';
import martyQuestThumb3 from '../assets/images/projects/marty-quest/mq-3-thumbnail.avif';
import martyQuestThumb4 from '../assets/images/projects/marty-quest/mq-4-thumbnail.avif';
import martyQuestThumb5 from '../assets/images/projects/marty-quest/mq-5-thumbnail.avif';
import martyQuestThumb6 from '../assets/images/projects/marty-quest/mq-6-thumbnail.avif';
import martyQuestThumb7 from '../assets/images/projects/marty-quest/mq-7-thumbnail.avif';
import martyQuestThumb8 from '../assets/images/projects/marty-quest/mq-8-thumbnail.avif';

import martyQuestlqMIN1 from '../assets/images/projects/marty-quest/mq-1-lqMIN.avif';
import martyQuestlqMIN2 from '../assets/images/projects/marty-quest/mq-2-lqMIN.avif';
import martyQuestlqMIN3 from '../assets/images/projects/marty-quest/mq-3-lqMIN.avif';
import martyQuestlqMIN4 from '../assets/images/projects/marty-quest/mq-4-lqMIN.avif';
import martyQuestlqMIN5 from '../assets/images/projects/marty-quest/mq-5-lqMIN.avif';
import martyQuestlqMIN6 from '../assets/images/projects/marty-quest/mq-6-lqMIN.avif';
import martyQuestlqMIN7 from '../assets/images/projects/marty-quest/mq-7-lqMIN.avif';
import martyQuestlqMIN8 from '../assets/images/projects/marty-quest/mq-8-lqMIN.avif';

import martyQuestlqMAX1 from '../assets/images/projects/marty-quest/mq-1-lqMAX.avif';
import martyQuestlqMAX2 from '../assets/images/projects/marty-quest/mq-2-lqMAX.avif';
import martyQuestlqMAX3 from '../assets/images/projects/marty-quest/mq-3-lqMAX.avif';
import martyQuestlqMAX4 from '../assets/images/projects/marty-quest/mq-4-lqMAX.avif';
import martyQuestlqMAX5 from '../assets/images/projects/marty-quest/mq-5-lqMAX.avif';
import martyQuestlqMAX6 from '../assets/images/projects/marty-quest/mq-6-lqMAX.avif';
import martyQuestlqMAX7 from '../assets/images/projects/marty-quest/mq-7-lqMAX.avif';
import martyQuestlqMAX8 from '../assets/images/projects/marty-quest/mq-8-lqMAX.avif';

import martyQuestrMIN1 from '../assets/images/projects/marty-quest/mq-1-rMIN.avif';
import martyQuestrMIN2 from '../assets/images/projects/marty-quest/mq-2-rMIN.avif';
import martyQuestrMIN3 from '../assets/images/projects/marty-quest/mq-3-rMIN.avif';
import martyQuestrMIN4 from '../assets/images/projects/marty-quest/mq-4-rMIN.avif';
import martyQuestrMIN5 from '../assets/images/projects/marty-quest/mq-5-rMIN.avif';
import martyQuestrMIN6 from '../assets/images/projects/marty-quest/mq-6-rMIN.avif';
import martyQuestrMIN7 from '../assets/images/projects/marty-quest/mq-7-rMIN.avif';
import martyQuestrMIN8 from '../assets/images/projects/marty-quest/mq-8-rMIN.avif';

import martyQuestrMAX1 from '../assets/images/projects/marty-quest/mq-1-rMAX.avif';
import martyQuestrMAX2 from '../assets/images/projects/marty-quest/mq-2-rMAX.avif';
import martyQuestrMAX3 from '../assets/images/projects/marty-quest/mq-3-rMAX.avif';
import martyQuestrMAX4 from '../assets/images/projects/marty-quest/mq-4-rMAX.avif';
import martyQuestrMAX5 from '../assets/images/projects/marty-quest/mq-5-rMAX.avif';
import martyQuestrMAX6 from '../assets/images/projects/marty-quest/mq-6-rMAX.avif';
import martyQuestrMAX7 from '../assets/images/projects/marty-quest/mq-7-rMAX.avif';
import martyQuestrMAX8 from '../assets/images/projects/marty-quest/mq-8-rMAX.avif';

type AllPhotosStructure = { [key: string]: ImagesVersionsInterface }

const allPhotos: AllPhotosStructure = {
    martyQuest: {
        thumbnail: [
            martyQuestThumb1,
            martyQuestThumb2,
            martyQuestThumb3,
            martyQuestThumb4,
            martyQuestThumb5,
            martyQuestThumb6,
            martyQuestThumb7,
            martyQuestThumb8,
            martyQuestVideo1,
        ],
        lowerQualityMin: [
            martyQuestlqMIN1,
            martyQuestlqMIN2,
            martyQuestlqMIN3,
            martyQuestlqMIN4,
            martyQuestlqMIN5,
            martyQuestlqMIN6,
            martyQuestlqMIN7,
            martyQuestlqMIN8,
            martyQuestVideo1,
        ],
        lowerQualityMax: [
            martyQuestlqMAX1,
            martyQuestlqMAX2,
            martyQuestlqMAX3,
            martyQuestlqMAX4,
            martyQuestlqMAX5,
            martyQuestlqMAX6,
            martyQuestlqMAX7,
            martyQuestlqMAX8,
            martyQuestVideo1,
        ],
        reducedMin: [
            martyQuestrMIN1,
            martyQuestrMIN2,
            martyQuestrMIN3,
            martyQuestrMIN4,
            martyQuestrMIN5,
            martyQuestrMIN6,
            martyQuestrMIN7,
            martyQuestrMIN8,
            martyQuestVideo1,
        ],
        reducedMax: [
            martyQuestrMAX1,
            martyQuestrMAX2,
            martyQuestrMAX3,
            martyQuestrMAX4,
            martyQuestrMAX5,
            martyQuestrMAX6,
            martyQuestrMAX7,
            martyQuestrMAX8,
            martyQuestVideo1,
        ]
    },
    littlesBabyTracker: {
        thumbnail: [],
        lowerQualityMin: [],
        lowerQualityMax: [],
        reducedMin: [],
        reducedMax: [],
    },
    dreamsForLittles: {
        thumbnail: [
            dreamsForLittlesThumb1,
            dreamsForLittlesThumb2,
            dreamsForLittlesThumb3,
            dreamsForLittlesThumb4,
            dreamsForLittlesThumb5,
            dreamsForLittlesVid1,
        ],
        lowerQualityMin: [
            dreamsForLittleslqMIN1,
            dreamsForLittleslqMIN2,
            dreamsForLittleslqMIN3,
            dreamsForLittleslqMIN4,
            dreamsForLittleslqMIN5,
            dreamsForLittlesVid1,
        ],
        lowerQualityMax: [
            dreamsForLittleslqMAX1,
            dreamsForLittleslqMAX2,
            dreamsForLittleslqMAX3,
            dreamsForLittleslqMAX4,
            dreamsForLittleslqMAX5,
            dreamsForLittlesVid1,
        ],
        reducedMin: [
            dreamsForLittlesrMIN1,
            dreamsForLittlesrMIN2,
            dreamsForLittlesrMIN3,
            dreamsForLittlesrMIN4,
            dreamsForLittlesrMIN5,
            dreamsForLittlesVid1,
        ],
        reducedMax: [
            dreamsForLittlesrMAX1,
            dreamsForLittlesrMAX2,
            dreamsForLittlesrMAX3,
            dreamsForLittlesrMAX4,
            dreamsForLittlesrMAX5,
            dreamsForLittlesVid1,
        ]
    },
    diyAlarmSystem: {
        thumbnail: [
            diyAlarmSystemThumb1,
            diyAlarmSystemThumb2,
            diyAlarmSystemVideo1,
        ],
        lowerQualityMin: [
            diyAlarmSystemlqMIN1,
            diyAlarmSystemlqMIN2,
            diyAlarmSystemVideo1,
        ],
        lowerQualityMax: [
            diyAlarmSystemlqMAX1,
            diyAlarmSystemlqMAX2,
            diyAlarmSystemVideo1,
        ],
        reducedMin: [
            diyAlarmSystemrMIN1,
            diyAlarmSystemrMIN2,
            diyAlarmSystemVideo1,
        ],
        reducedMax: [
            diyAlarmSystemrMAX1,
            diyAlarmSystemrMAX2,
            diyAlarmSystemVideo1,
        ]
    },
    smartPot: {
        thumbnail: [
            smartPotDeviceThumb,
            smartPotDashboardThumb,
            smartPotElectronicsThumb,
            smartPotPumpThumb,
            smartPotVideo,
        ],
        lowerQualityMin: [
            smartPotDeviceLqMIN,
            smartPotDashboardLqMIN,
            smartPotElectronicsLqMIN,
            smartPotPumpLqMIN,
            smartPotVideo,
        ],
        lowerQualityMax: [
            smartPotDeviceLqMAX,
            smartPotDashboardLqMAX,
            smartPotElectronicsLqMAX,
            smartPotPumpLqMAX,
            smartPotVideo,
        ],
        reducedMin: [
            smartPotDeviceRMIN,
            smartPotDashboardRMIN,
            smartPotElectronicsRMIN,
            smartPotPumpRMIN,
            smartPotVideo,
        ],
        reducedMax: [
            smartPotDeviceRMAX,
            smartPotDashboardRMAX,
            smartPotElectronicsRMAX,
            smartPotPumpRMAX,
            smartPotVideo,
        ]
    },
    smartMirror: {
        thumbnail: [
            smartMirrorFinishedThumb,
            smartMirrorUiThumb,
            smartMirrorMountedVideo,
            smartMirrorBackThumb,
            smartMirrorSensorThumb,
            smartMirrorPiThumb,
            smartMirrorPrototypeVideo,
        ],
        lowerQualityMin: [
            smartMirrorFinishedlqMIN,
            smartMirrorUilqMIN,
            smartMirrorMountedVideo,
            smartMirrorBacklqMIN,
            smartMirrorSensorlqMIN,
            smartMirrorPilqMIN,
            smartMirrorPrototypeVideo,
        ],
        lowerQualityMax: [
            smartMirrorFinishedlqMAX,
            smartMirrorUilqMAX,
            smartMirrorMountedVideo,
            smartMirrorBacklqMAX,
            smartMirrorSensorlqMAX,
            smartMirrorPilqMAX,
            smartMirrorPrototypeVideo,
        ],
        reducedMin: [
            smartMirrorFinishedrMIN,
            smartMirrorUirMIN,
            smartMirrorMountedVideo,
            smartMirrorBackrMIN,
            smartMirrorSensorrMIN,
            smartMirrorPirMIN,
            smartMirrorPrototypeVideo,
        ],
        reducedMax: [
            smartMirrorFinishedrMAX,
            smartMirrorUirMAX,
            smartMirrorMountedVideo,
            smartMirrorBackrMAX,
            smartMirrorSensorrMAX,
            smartMirrorPirMAX,
            smartMirrorPrototypeVideo,
        ]
    },
    newsHub: {
        thumbnail: [
            newsHubVid1,
        ],
        lowerQualityMin: [
            newsHubVid1,
        ],
        lowerQualityMax: [
            newsHubVid1,
        ],
        reducedMin: [
            newsHubVid1,
        ],
        reducedMax: [
            newsHubVid1,
        ]
    },
    scratchJrWeb: {
        thumbnail: [
            scratchJrWebThumb1,
            scratchJrWebThumb2,
            scratchJrWebThumb3,
        ],
        lowerQualityMin: [
            scratchJrWeblqMIN1,
            scratchJrWeblqMIN2,
            scratchJrWeblqMIN3,
        ],
        lowerQualityMax: [
            scratchJrWeblqMAX1,
            scratchJrWeblqMAX2,
            scratchJrWeblqMAX3,
        ],
        reducedMin: [
            scratchJrWebrMIN1,
            scratchJrWebrMIN2,
            scratchJrWebrMIN3,
        ],
        reducedMax: [
            scratchJrWebrMAX1,
            scratchJrWebrMAX2,
            scratchJrWebrMAX3,
        ]
    },
    sensorsDashboard: {
        thumbnail: [
            sensorsDashboardThumb1,
            sensorsDashboardVid1,
            sensorsDashboardVid2,
        ],
        lowerQualityMin: [
            sensorsDashboardlqMIN1,
            sensorsDashboardVid1,
            sensorsDashboardVid2,
        ],
        lowerQualityMax: [
            sensorsDashboardlqMAX1,
            sensorsDashboardVid1,
            sensorsDashboardVid2,
        ],
        reducedMin: [
            sensorsDashboardrMIN1,
            sensorsDashboardVid1,
            sensorsDashboardVid2,
        ],
        reducedMax: [
            sensorsDashboardrMAX1,
            sensorsDashboardVid1,
            sensorsDashboardVid2,
        ]
    },
    blocksToPythonTranspiler: {
        thumbnail: [
            blocksToPythonThumb1,
            blocksToPythonThumb2,
            blocksToPythonVid1,
        ],
        lowerQualityMin: [
            blocksToPythonlqMIN1,
            blocksToPythonlqMIN2,
            blocksToPythonVid1,
        ],
        lowerQualityMax: [
            blocksToPythonlqMAX1,
            blocksToPythonlqMAX2,
            blocksToPythonVid1,
        ],
        reducedMin: [
            blocksToPythonrMIN1,
            blocksToPythonrMIN2,
            blocksToPythonVid1,
        ],
        reducedMax: [
            blocksToPythonrMAX1,
            blocksToPythonrMAX2,
            blocksToPythonVid1,
        ]
    },
    cogMiniGames: {
        thumbnail: [
            miniGamesThumb1,
            miniGamesThumb2,
            miniGamesThumb3,
            miniGamesVid1,
            miniGamesVid2,
            miniGamesVid3,
        ],
        lowerQualityMin: [
            miniGameslqMIN1,
            miniGameslqMIN2,
            miniGameslqMIN3,
            miniGamesVid1,
            miniGamesVid2,
            miniGamesVid3,
        ],
        lowerQualityMax: [
            miniGameslqMAX1,
            miniGameslqMAX2,
            miniGameslqMAX3,
            miniGamesVid1,
            miniGamesVid2,
            miniGamesVid3,
        ],
        reducedMin: [
            miniGamesrMIN1,
            miniGamesrMIN2,
            miniGamesrMIN3,
            miniGamesVid1,
            miniGamesVid2,
            miniGamesVid3,
        ],
        reducedMax: [
            miniGamesrMAX1,
            miniGamesrMAX2,
            miniGamesrMAX3,
            miniGamesVid1,
            miniGamesVid2,
            miniGamesVid3,
        ]
    },
    codeAssess: {
        thumbnail: [
            codeAssessThumb1,
            codeAssessThumb2,
            codeAssessThumb3,
            codeAssessThumb4,
            codeAssessThumb5,
            codeAssessThumb6,
            codeAssessVideo1,
            codeAssessVideo2,
            codeAssessVideo3,
            codeAssessVideo4,
        ],
        lowerQualityMin: [
            codeAssesslqMIN1,
            codeAssesslqMIN2,
            codeAssesslqMIN3,
            codeAssesslqMIN4,
            codeAssesslqMIN5,
            codeAssesslqMIN6,
            codeAssessVideo1,
            codeAssessVideo2,
            codeAssessVideo3,
            codeAssessVideo4,
        ],
        lowerQualityMax: [
            codeAssesslqMAX1,
            codeAssesslqMAX2,
            codeAssesslqMAX3,
            codeAssesslqMAX4,
            codeAssesslqMAX5,
            codeAssesslqMAX6,
            codeAssessVideo1,
            codeAssessVideo2,
            codeAssessVideo3,
            codeAssessVideo4,
        ],
        reducedMin: [
            codeAssessrMIN1,
            codeAssessrMIN2,
            codeAssessrMIN3,
            codeAssessrMIN4,
            codeAssessrMIN5,
            codeAssessrMIN6,
            codeAssessVideo1,
            codeAssessVideo2,
            codeAssessVideo3,
            codeAssessVideo4,
        ],
        reducedMax: [
            codeAssessrMAX1,
            codeAssessrMAX2,
            codeAssessrMAX3,
            codeAssessrMAX4,
            codeAssessrMAX5,
            codeAssessrMAX6,
            codeAssessVideo1,
            codeAssessVideo2,
            codeAssessVideo3,
            codeAssessVideo4,
        ]
    },
    learningPortal: {
        thumbnail: [
            learningPortalThumb1,
            learningPortalThumb2,
            learningPortalVideo1,
        ],
        lowerQualityMin: [
            learningPortallqMIN1,
            learningPortallqMIN2,
            learningPortalVideo1,
        ],
        lowerQualityMax: [
            learningPortallqMAX1,
            learningPortallqMAX2,
            learningPortalVideo1,
        ],
        reducedMin: [
            learningPortallrMIN1,
            learningPortallrMIN2,
            learningPortalVideo1,
        ],
        reducedMax: [
            learningPortallrMAX1,
            learningPortallrMAX2,
            learningPortalVideo1,
        ]
    },
    martyController: {
        thumbnail: [
            martyControllerThumb1,
            martyControllerThumb2,
            martyControllerThumb3,
            martyControllerThumb4,
            martyControllerVideo1,
        ],
        lowerQualityMin: [
            martyControllerlqMIN1,
            martyControllerlqMIN2,
            martyControllerlqMIN3,
            martyControllerlqMIN4,
            martyControllerVideo1,
        ],
        lowerQualityMax: [
            martyControllerlqMAX1,
            martyControllerlqMAX2,
            martyControllerlqMAX3,
            martyControllerlqMAX4,
            martyControllerVideo1,
        ],
        reducedMin: [
            martyControllerrMIN1,
            martyControllerrMIN2,
            martyControllerrMIN3,
            martyControllerrMIN4,
            martyControllerVideo1,
        ],
        reducedMax: [
            martyControllerrMAX1,
            martyControllerrMAX2,
            martyControllerrMAX3,
            martyControllerrMAX4,
            martyControllerVideo1,
        ]
    },
    worldAtlas: {
        thumbnail: [
            worldAtlasThumb1,
            worldAtlasThumb2,
            worldAtlasThumb3,
        ],
        lowerQualityMin: [
            worldAtlaslqMIN1,
            worldAtlaslqMIN2,
            worldAtlaslqMIN3
        ],
        lowerQualityMax: [
            worldAtlaslqMAX1,
            worldAtlaslqMAX2,
            worldAtlaslqMAX3,
        ],
        reducedMin: [
            worldAtlasrMIN1,
            worldAtlasrMIN2,
            worldAtlasrMIN3
        ],
        reducedMax: [
            worldAtlasrMAX1,
            worldAtlasrMAX2,
            worldAtlasrMAX3
        ]
    },

    restaurant: {
        thumbnail: [
            restaurantThumb1,
            restaurantThumb2,
            restaurantThumb3,
            restaurantThumb4,
            restaurantThumb5,
            restaurantThumb6,
            restaurantThumb7,
            restaurantThumb8,
        ],
        lowerQualityMin: [
            restaurantlqMIN1,
            restaurantlqMIN2,
            restaurantlqMIN3,
            restaurantlqMIN4,
            restaurantlqMIN5,
            restaurantlqMIN6,
            restaurantlqMIN7,
            restaurantlqMIN8,
        ],
        lowerQualityMax: [
            restaurantlqMAX1,
            restaurantlqMAX2,
            restaurantlqMAX3,
            restaurantlqMAX4,
            restaurantlqMAX5,
            restaurantlqMAX6,
            restaurantlqMAX7,
            restaurantlqMAX8,
        ],
        reducedMin: [
            restaurantrMIN1,
            restaurantrMIN2,
            restaurantrMIN3,
            restaurantrMIN4,
            restaurantrMIN5,
            restaurantrMIN6,
            restaurantrMIN7,
            restaurantrMIN8,
        ],
        reducedMax: [
            restaurantrMAX1,
            restaurantrMAX2,
            restaurantrMAX3,
            restaurantrMAX4,
            restaurantrMAX5,
            restaurantrMAX6,
            restaurantrMAX7,
            restaurantrMAX8,
        ]
    },

    checkers: {
        thumbnail: [
            checkersThumb1,
            checkersThumb2,
            checkersThumb3,
            checkersThumb4,
            checkersThumb5,
            checkersThumb6,
            checkersThumb7,
            checkersThumb8,
            checkersThumb9,
        ],
        lowerQualityMin: [
            checkerslqMIN1,
            checkerslqMIN2,
            checkerslqMIN3,
            checkerslqMIN4,
            checkerslqMIN5,
            checkerslqMIN6,
            checkerslqMIN7,
            checkerslqMIN8,
            checkerslqMIN9,
        ],
        lowerQualityMax: [
            checkerslqMAX1,
            checkerslqMAX2,
            checkerslqMAX3,
            checkerslqMAX4,
            checkerslqMAX5,
            checkerslqMAX6,
            checkerslqMAX7,
            checkerslqMAX8,
            checkerslqMAX9,
        ],
        reducedMin: [
            checkersrMIN1,
            checkersrMIN2,
            checkersrMIN3,
            checkersrMIN4,
            checkersrMIN5,
            checkersrMIN6,
            checkersrMIN7,
            checkersrMIN8,
            checkersrMIN9,
        ],
        reducedMax: [
            checkersrMAX1,
            checkersrMAX2,
            checkersrMAX3,
            checkersrMAX4,
            checkersrMAX5,
            checkersrMAX6,
            checkersrMAX7,
            checkersrMAX8,
            checkersrMAX9,
        ]
    },

    reinforcementLearning: {
        thumbnail: [
            rlThumb1,
            rlThumb2,
            rlThumb3,
            rlThumb4,
        ],
        lowerQualityMin: [
            rllqMIN1,
            rllqMIN2,
            rllqMIN3,
            rllqMIN4,
        ],
        lowerQualityMax: [
            rllqMAX1,
            rllqMAX2,
            rllqMAX3,
            rllqMAX4,
        ],
        reducedMin: [
            rlrMIN1,
            rlrMIN2,
            rlrMIN3,
            rlrMIN4,
        ],
        reducedMax: [
            rlrMAX1,
            rlrMAX2,
            rlrMAX3,
            rlrMAX4,
        ]
    },

    xcovers: {
        thumbnail: [
            xcoversThumb1,
            xcoversThumb2,
            xcoversThumb3,
            xcoversThumb4,
        ],
        lowerQualityMin: [
            xcoverslqMIN1,
            xcoverslqMIN2,
            xcoverslqMIN3,
            xcoverslqMIN4,
        ],
        lowerQualityMax: [
            xcoverslqMAX1,
            xcoverslqMAX2,
            xcoverslqMAX3,
            xcoverslqMAX4,
        ],
        reducedMin: [
            xcoversrMIN1,
            xcoversrMIN2,
            xcoversrMIN3,
            xcoversrMIN4,
        ],
        reducedMax: [
            xcoversrMAX1,
            xcoversrMAX2,
            xcoversrMAX3,
            xcoversrMAX4,
        ]
    },

    onlineExperiment: {
        thumbnail: [
            oeThumb2,
            oeThumb3,
            oeThumb4,
            oeThumb5,
        ],
        lowerQualityMin: [
            oelqMIN2,
            oelqMIN3,
            oelqMIN4,
            oelqMIN5,
        ],
        lowerQualityMax: [
            oelqMAX2,
            oelqMAX3,
            oelqMAX4,
            oelqMAX5,
        ],
        reducedMin: [
            oerMIN2,
            oerMIN3,
            oerMIN4,
            oerMIN5,
        ],
        reducedMax: [
            oerMAX2,
            oerMAX3,
            oerMAX4,
            oerMAX5,
        ]
    },
    blackJack: {
        thumbnail: [
            blackJackThumb3,
            blackJackThumb2,
            blackJackThumb1,
            blackJackVid1,
            blackJackVid2,
        ],
        lowerQualityMin: [
            blackJacklqMIN3,
            blackJacklqMIN2,
            blackJacklqMIN1,
            blackJackVid1,
            blackJackVid2,
        ],
        lowerQualityMax: [
            blackJacklqMAX3,
            blackJacklqMAX2,
            blackJacklqMAX1,
            blackJackVid1,
            blackJackVid2,
        ],
        reducedMin: [
            blackJackrMIN3,
            blackJackrMIN2,
            blackJackrMIN1,
            blackJackVid1,
            blackJackVid2,
        ],
        reducedMax: [
            blackJackrMAX3,
            blackJackrMAX2,
            blackJackrMAX1,
            blackJackVid1,
            blackJackVid2,
        ]
    },
    networkGraph: {
        thumbnail: [
            networkGraphThumb1,
            networkGraphThumb2,
            networkGraphThumb3,
            networkGraphVid1,
            networkGraphVid2,
        ],
        lowerQualityMin: [
            networkGraphlqMIN1,
            networkGraphlqMIN2,
            networkGraphlqMIN3,
            networkGraphVid1,
            networkGraphVid2,
        ],
        lowerQualityMax: [
            networkGraphlqMAX1,
            networkGraphlqMAX2,
            networkGraphlqMAX3,
            networkGraphVid1,
            networkGraphVid2,
        ],
        reducedMin: [
            networkGraphrMIN1,
            networkGraphrMIN2,
            networkGraphrMIN3,
            networkGraphVid1,
            networkGraphVid2,
        ],
        reducedMax: [
            networkGraphrMAX1,
            networkGraphrMAX2,
            networkGraphrMAX3,
            networkGraphVid1,
            networkGraphVid2,
        ]
    },
    machineLearningRobotical: {
        thumbnail: [
            machineLearningRoboticalThumb1,
            machineLearningRoboticalThumb2,
            machineLearningRoboticalThumb3,
            machineLearningRoboticallVideo1,
        ],
        lowerQualityMin: [
            machineLearningRoboticallqMIN1,
            machineLearningRoboticallqMIN2,
            machineLearningRoboticallqMIN3,
            machineLearningRoboticallVideo1,
        ],
        lowerQualityMax: [
            machineLearningRoboticallqMAX1,
            machineLearningRoboticallqMAX2,
            machineLearningRoboticallqMAX3,
            machineLearningRoboticallVideo1,
        ],
        reducedMin: [
            machineLearningRoboticallrMIN1,
            machineLearningRoboticallrMIN2,
            machineLearningRoboticallrMIN3,
            machineLearningRoboticallVideo1,
        ],
        reducedMax: [
            machineLearningRoboticallrMAX1,
            machineLearningRoboticallrMAX2,
            machineLearningRoboticallrMAX3,
            machineLearningRoboticallVideo1,
        ]
    }
};


export default allPhotos;
